import { NgModule, APP_ID, makeStateKey, TransferState, CUSTOM_ELEMENTS_SCHEMA, ENVIRONMENT_INITIALIZER, PLATFORM_ID } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { Router } from '@angular/router';

// import { MatLegacyDialogModule as MatDialogModule } from '@angular/material/legacy-dialog';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { AppConfigService, IS_SSRENDERED_APP, FeatureDetectionService } from '@citi-gcg-173875/citi-utils';
import { CommonModule } from '@angular/common';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { CommonwealthHttpModule } from './shared/commonwealth-http/commonwealth-http.module';
import {
    NgxWebstorageModule,
    LocalStorageService,
    SessionStorageService
} from 'ngx-webstorage';

import { environment } from '../environments/environment';
import { HTTP_INTERCEPTORS } from '@angular/common/http';  
import { DCLocationInterceptor } from './services/dcLocation.interceptor';

import {
    ContentService,
    LanguageToggleService,
    AdobeService,
    popupService,
    windowService,
    GuidService,
    ProfilingService,
    SvcServices,
    DmarService,
    PopupModalService,
    HoneyPotService,
    CONFIG,
    BackendService,
    CrsFidoService,
    E2eService,
    SiteCatalystService,
    SessionTimeOutService,
} from './services';
import { WINDOW_PROVIDER } from '@citi-gcg-173875/citi-utils';

import { ChatbotService } from './shared/common-component/service/chatbot.service';
import { CoreModule } from './core/core.module';
import { HttpClient, HttpClientModule } from "@angular/common/http";
import { Observable } from 'rxjs';
import { SignonService } from './services/signon.service';

@NgModule({
    declarations: [
        AppComponent
    ],
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        AppRoutingModule,
        CoreModule,
        CommonModule,
        NgxWebstorageModule.forRoot(),
        CommonwealthHttpModule,
        HttpClientModule,
    ],
    exports: [
        BrowserAnimationsModule
    ],
    providers: [
        { provide: APP_ID, useValue: 'SSRContainer' },
        { provide: CONFIG, useValue: { api: environment.api } },
        LocalStorageService,
        SessionStorageService,
        WINDOW_PROVIDER,
        ContentService,
        LanguageToggleService,
        AdobeService,
        popupService,
        windowService,
        GuidService,
        ProfilingService,
        SvcServices,
        DmarService,
        PopupModalService,
        E2eService,
        SiteCatalystService,
        HoneyPotService,
        SignonService,
        BackendService,
        ChatbotService,
        CrsFidoService,
        FeatureDetectionService,
        SessionTimeOutService,
        AppConfigService,
        { provide: HTTP_INTERCEPTORS, useClass: DCLocationInterceptor, multi: true },
        {
            provide: IS_SSRENDERED_APP,
            useValue: true
        },
    ],
    bootstrap: [AppComponent],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class AppModule {

    constructor(public _appConfigService: AppConfigService, private _router: Router, private _transferState: TransferState) {
        let domData = {};

        const DOM_DATA_KEY = makeStateKey<string>('DomData');

        if (this._transferState.hasKey(DOM_DATA_KEY)) {
            let blank_obj: any = {};
            domData = this._transferState.get(DOM_DATA_KEY, blank_obj);
        }

        let appGlobalConfigData = domData['appGlobalConfigData'];

        let configData = (typeof appGlobalConfigData !== 'undefined') ? appGlobalConfigData : environment;
        this._appConfigService.setAppConfig(configData);
        let api = this._appConfigService.getConfig('api');

        let currentRoute = domData['currentRoute'];
        if (typeof currentRoute !== "undefined") {
            this._router.navigateByUrl(currentRoute);
        }
    }
}
